module.exports = __webpack_public_path__ + "img/circle-table-5.18cdaab0.png";